import { render, staticRenderFns } from "./SportelloContrattiProvvisoriView.vue?vue&type=template&id=9a91735a&"
import script from "./SportelloContrattiProvvisoriView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiProvvisoriView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports